import React from "react";
import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
// import OwnerFooter from "../components/OwnerFooter";

const PropertyOwner = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <>
    <PropertyOwnerNavbar/>
    
    <div style={{ paddingBottom: 120 , marginTop:'5%'}}>

      {/* Header */}
      <div style={{
        background: "linear-gradient(135deg,#8a2d5d,#5a1740)",
        color: "#fff",
        padding: 30,
        borderBottomLeftRadius: 40,
        borderBottomRightRadius: 40,
      }}>
        {/* <h3>Good Afternoon,</h3> */}
        <h1>{user?.full_name || "Owner"}</h1>
        <p>👑 Property Owner</p>
      </div>

      {/* Stats */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
        gap: 20,
        padding: 20
      }}>
        {[
          ["1 Hectare", "Total Land Holdings"],
          ["10 Plots", "Total Inventory"],
          ["₹ 0.6 Cr", "Revenue"],
          ["3 Agents", "Active Team"],
        ].map(([title, sub]) => (
          <div key={title} style={{
            background: "#fff",
            padding: 20,
            borderRadius: 16,
            boxShadow: "0 5px 15px rgba(0,0,0,0.08)"
          }}>
            <h2>{title}</h2>
            <p style={{ color: "#666" }}>{sub}</p>
          </div>
        ))}
      </div>

      {/* <OwnerFooter /> */}
    </div>

    </>
  );
};

export default PropertyOwner;
